import React from "react";
import { useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";

const ScrewPicker = ({ maxL, nodeTypeId, eta, minL, startvalue, linkdoc, onCustomEvent }, ref) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = React.useState(startvalue);
  const [maxH, setMaxH] = React.useState(maxL);
  const [minH, setMinH] = React.useState(minL);
  const [nodeType, setNodeType] = React.useState(nodeTypeId);
  const [supportEta] = React.useState(eta);
  const [doc, setDoc] = React.useState(linkdoc);

  const screwDatabase = [
    { label: "Constr.TC-6x80", value: "1", minL: 80, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x100", value: "2", minL: 100, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x120", value: "3", minL: 120, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x140", value: "4", minL: 140, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x160", value: "5", minL: 160, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x180", value: "6", minL: 180, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x200", value: "7", minL: 200, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x220", value: "8", minL: 220, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x240", value: "9", minL: 240, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x260", value: "10", minL: 260, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x280", value: "11", minL: 280, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-6x300", value: "12", minL: 300, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA180817.pdf" },
    { label: "Constr.TC-8x120", value: "13", minL: 120, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x140", value: "14", minL: 140, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x160", value: "15", minL: 160, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x180", value: "16", minL: 180, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x200", value: "17", minL: 200, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x220", value: "18", minL: 220, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x240", value: "19", minL: 240, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x260", value: "20", minL: 260, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x280", value: "21", minL: 280, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x300", value: "22", minL: 300, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x325", value: "23", minL: 325, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x350", value: "24", minL: 350, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x375", value: "25", minL: 375, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x400", value: "26", minL: 400, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x450", value: "27", minL: 450, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x500", value: "28", minL: 500, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-8x600", value: "29", minL: 600, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x200", value: "30", minL: 200, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x240", value: "31", minL: 240, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x280", value: "32", minL: 280, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x300", value: "33", minL: 300, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x325", value: "34", minL: 325, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x350", value: "35", minL: 350, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x375", value: "36", minL: 375, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x400", value: "37", minL: 400, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x450", value: "38", minL: 450, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x500", value: "39", minL: 500, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x600", value: "40", minL: 600, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x700", value: "41", minL: 700, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x800", value: "42", minL: 800, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TC-10x1000", value: "43", minL: 1000, nodes: [1, 100, 2, 3, 30, 7], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x120", value: "100", minL: 120, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x140", value: "101", minL: 140, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x160", value: "102", minL: 160, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x180", value: "103", minL: 180, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x200", value: "104", minL: 200, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x220", value: "105", minL: 220, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x240", value: "106", minL: 240, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x260", value: "107", minL: 260, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x280", value: "108", minL: 280, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x300", value: "109", minL: 300, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x325", value: "110", minL: 325, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x350", value: "111", minL: 350, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x375", value: "112", minL: 375, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x400", value: "113", minL: 400, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x450", value: "114", minL: 450, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x500", value: "115", minL: 500, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-8x600", value: "116", minL: 500, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x120", value: "117", minL: 120, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x160", value: "118", minL: 160, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x180", value: "119", minL: 180, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x200", value: "120", minL: 200, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x220", value: "121", minL: 220, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x240", value: "122", minL: 240, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x260", value: "123", minL: 260, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x280", value: "124", minL: 280, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x300", value: "125", minL: 300, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x325", value: "126", minL: 325, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x350", value: "127", minL: 350, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x375", value: "128", minL: 375, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x400", value: "129", minL: 400, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x450", value: "130", minL: 450, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x500", value: "131", minL: 500, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x600", value: "132", minL: 600, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x700", value: "133", minL: 700, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x800", value: "134", minL: 800, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-10x1000", value: "135", minL: 1000, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x200", value: "136", minL: 200, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x240", value: "137", minL: 240, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x300", value: "138", minL: 300, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x350", value: "139", minL: 350, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x400", value: "140", minL: 400, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x500", value: "141", minL: 500, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x600", value: "142", minL: 600, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x700", value: "143", minL: 700, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x800", value: "144", minL: 800, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "Constr.TS-12x1000", value: "145", minL: 1000, nodes: [1, 2, 3, 30, 7, 20], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X280", value: "200", minL: 280, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X300", value: "201", minL: 300, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X320", value: "202", minL: 320, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X340", value: "203", minL: 340, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X360", value: "204", minL: 360, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X400", value: "205", minL: 400, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X450", value: "206", minL: 450, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X480", value: "207", minL: 480, nodes: [8], doc: "ETA120373.pdf" },
    { label: "ISOLANT TC-8,0X520", value: "208", minL: 520, nodes: [8], doc: "ETA120373.pdf" },
    { label: "SAF 7x73", value: "300", minL: 73, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x93", value: "301", minL: 93, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x113", value: "302", minL: 113, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x133", value: "303", minL: 133, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x153", value: "304", minL: 153, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x173", value: "305", minL: 173, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x193", value: "306", minL: 193, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x213", value: "307", minL: 213, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SAF 7x233", value: "308", minL: 233, nodes: [4, 5, 50, 6], doc: "SAF.pdf" },
    { label: "SPT 8x70", value: "400", minL: 70, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 8x80", value: "401", minL: 80, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 8x90", value: "402", minL: 90, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 8x100", value: "403", minL: 100, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 8x110", value: "404", minL: 110, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 8x130", value: "405", minL: 130, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 8x140", value: "406", minL: 140, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 12x60", value: "407", minL: 60, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x70", value: "408", minL: 70, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x80", value: "409", minL: 80, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x90", value: "410", minL: 90, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x100", value: "411", minL: 100, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x110", value: "412", minL: 110, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x120", value: "413", minL: 120, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x130", value: "414", minL: 130, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x140", value: "415", minL: 140, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x150", value: "416", minL: 150, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x160", value: "417", minL: 160, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x170", value: "418", minL: 170, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x180", value: "419", minL: 180, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x190", value: "420", minL: 190, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x200", value: "421", minL: 200, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x220", value: "422", minL: 220, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x240", value: "423", minL: 240, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x250", value: "424", minL: 250, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 12x300", value: "425", minL: 300, nodes: [4, 5, 60], doc: "SPT.pdf" },
    { label: "SPT 16x100", value: "426", minL: 100, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x110", value: "427", minL: 110, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x120", value: "428", minL: 120, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x130", value: "429", minL: 130, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x140", value: "430", minL: 140, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x150", value: "431", minL: 150, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x160", value: "432", minL: 160, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x170", value: "433", minL: 170, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x180", value: "434", minL: 180, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x190", value: "435", minL: 190, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x200", value: "436", minL: 200, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x220", value: "437", minL: 220, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x240", value: "438", minL: 240, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 16x250", value: "439", minL: 250, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x120", value: "440", minL: 120, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x140", value: "441", minL: 140, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x160", value: "442", minL: 160, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x180", value: "443", minL: 180, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x200", value: "444", minL: 200, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x220", value: "445", minL: 220, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x240", value: "446", minL: 240, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x250", value: "447", minL: 250, nodes: [4, 5], doc: "SPT.pdf" },
    { label: "SPT 20x300", value: "448", minL: 300, nodes: [4, 5], doc: "SPT.pdf" },

    { label: "WR-HECO 13.0x400", value: "500", minL: 400, nodes: [1, 2, 3, 7], doc: "ETA120062.pdf" },
    { label: "WR-HECO 13.0x500", value: "501", minL: 500, nodes: [1, 2, 3, 7], doc: "ETA120062.pdf" },
    { label: "WR-HECO 13.0x600", value: "502", minL: 600, nodes: [1, 2, 3, 7], doc: "ETA120062.pdf" },
    { label: "WR-HECO 13.0x700", value: "503", minL: 700, nodes: [1, 2, 3, 7], doc: "ETA120062.pdf" },
    { label: "WR-HECO 13.0x800", value: "504", minL: 800, nodes: [1, 2, 3, 7], doc: "ETA120062.pdf" },
    { label: "WR-HECO 13.0x900", value: "505", minL: 900, nodes: [1, 2, 3, 7], doc: "ETA120062.pdf" },
    { label: "WR-HECO 13.0x1000", value: "506", minL: 1000, nodes: [1, 2, 3, 7], doc: "ETA120062.pdf" },

    { label: "PERF. ST. TB 6,0x80", value: "600", minL: 80, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 6,0x100", value: "601", minL: 100, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 6,0x120", value: "602", minL: 120, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 6,0x140", value: "603", minL: 140, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 6,0x160", value: "604", minL: 160, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 6,0x180", value: "605", minL: 180, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 6,0x200", value: "606", minL: 200, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x80", value: "607", minL: 80, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x100", value: "608", minL: 100, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x120", value: "609", minL: 120, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x140", value: "610", minL: 140, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x160", value: "611", minL: 160, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x180", value: "612", minL: 180, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x200", value: "613", minL: 200, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x220", value: "614", minL: 220, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x240", value: "615", minL: 240, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x260", value: "616", minL: 260, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x280", value: "617", minL: 280, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x300", value: "618", minL: 300, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x320", value: "619", minL: 320, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x340", value: "620", minL: 340, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x360", value: "621", minL: 360, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x380", value: "622", minL: 380, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 8,0x400", value: "623", minL: 400, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x160", value: "624", minL: 160, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x180", value: "625", minL: 180, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x200", value: "626", minL: 200, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x220", value: "627", minL: 220, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x240", value: "628", minL: 240, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x260", value: "629", minL: 260, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x280", value: "630", minL: 280, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x300", value: "631", minL: 300, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x320", value: "632", minL: 320, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x340", value: "633", minL: 340, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x360", value: "634", minL: 360, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x380", value: "635", minL: 380, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. TB 10,0x400", value: "636", minL: 400, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x60", value: "715", minL: 60, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x70", value: "716", minL: 70, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x80", value: "717", minL: 80, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x90", value: "718", minL: 90, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x100", value: "719", minL: 100, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x120", value: "720", minL: 120, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x140", value: "721", minL: 140, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x160", value: "722", minL: 160, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x180", value: "723", minL: 180, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x200", value: "724", minL: 200, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x220", value: "725", minL: 220, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x240", value: "726", minL: 240, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x260", value: "727", minL: 260, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x280", value: "728", minL: 280, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 6,0x300", value: "729", minL: 300, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x80", value: "730", minL: 80, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x100", value: "731", minL: 100, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x120", value: "732", minL: 120, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x140", value: "733", minL: 140, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x160", value: "734", minL: 160, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x180", value: "735", minL: 180, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x200", value: "736", minL: 200, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x220", value: "737", minL: 220, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x240", value: "738", minL: 240, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x260", value: "739", minL: 260, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x280", value: "740", minL: 280, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x300", value: "741", minL: 300, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x320", value: "742", minL: 320, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x340", value: "743", minL: 340, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x360", value: "744", minL: 360, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x380", value: "745", minL: 380, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x400", value: "746", minL: 400, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x480", value: "747", minL: 480, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 8,0x500", value: "748", minL: 500, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x80", value: "749", minL: 80, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x100", value: "750", minL: 100, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x120", value: "751", minL: 120, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x140", value: "752", minL: 140, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x160", value: "753", minL: 160, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x180", value: "754", minL: 180, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x200", value: "755", minL: 200, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x220", value: "756", minL: 220, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x240", value: "757", minL: 240, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x260", value: "758", minL: 260, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x280", value: "759", minL: 280, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x300", value: "760", minL: 300, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x320", value: "761", minL: 320, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x340", value: "762", minL: 340, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x360", value: "763", minL: 360, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x380", value: "764", minL: 380, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x400", value: "765", minL: 400, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x440", value: "766", minL: 440, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x480", value: "767", minL: 480, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 10,0x500", value: "768", minL: 500, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x100", value: "769", minL: 100, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x120", value: "770", minL: 120, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x140", value: "771", minL: 140, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x160", value: "772", minL: 160, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x180", value: "773", minL: 180, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x200", value: "774", minL: 200, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x220", value: "775", minL: 220, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x240", value: "776", minL: 240, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x260", value: "777", minL: 260, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x280", value: "778", minL: 280, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x300", value: "779", minL: 300, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x320", value: "780", minL: 320, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x340", value: "781", minL: 340, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x360", value: "782", minL: 360, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x380", value: "783", minL: 380, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x400", value: "784", minL: 400, nodes: [30], doc: "ETA120373.pdf" },
    { label: "PERF. ST. 12,0x600", value: "785", minL: 600, nodes: [30], doc: "ETA120373.pdf" },

    { label: "PERF.BLUE 6,0x60", value: "800", minL: 60, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x70", value: "801", minL: 70, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x80", value: "802", minL: 80, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x90", value: "803", minL: 90, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x100", value: "804", minL: 100, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x120", value: "805", minL: 120, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x140", value: "806", minL: 140, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x160", value: "807", minL: 160, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x180", value: "808", minL: 180, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x200", value: "809", minL: 200, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x220", value: "810", minL: 220, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x240", value: "811", minL: 240, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x260", value: "812", minL: 260, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x280", value: "813", minL: 280, nodes: [30], doc: "ETA180817.pdf" },
    { label: "PERF.BLUE 6,0x300", value: "814", minL: 300, nodes: [30], doc: "ETA180817.pdf" },

    { label: "T-CON 8,0x155", value: "900", minL: 155, nodes: [9], doc: "ETA180829.pdf" },
    { label: "T-CON 8,0x205", value: "901", minL: 205, nodes: [9], doc: "ETA180829.pdf" },
  ];
  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
    setDoc(screwDatabase.find((e) => e.value === value).doc);
    sendDataToParent(value);
    console.log(event.target.value);
  };
  useImperativeHandle(ref, () => ({
    getData: getData,
    setMaxL: setMaxL,
    setMinL: setMinL,
    setNodeId: setNodeId,
    setLinkDoc: setLink,
    setValue: setSelectValue,
  }));
  const getData = () => {
    return selectValue;
  };
  const sendDataToParent = (value) => {
    if (typeof onCustomEvent != "undefined") {
      onCustomEvent(value);
    }
  };

  const getOptions = () => {
    var newList = [];
    var found = 0;
    for (const element of screwDatabase) {
      if (element.minL <= maxH && element.minL > minH && element.nodes.includes(nodeType)) {
        newList.push(element);
        if (selectValue === element.value) {
          found = 1;
        }
      }
    }
    if (found === 0 && newList.length > 0) {
      setSelectValue(newList[0].value);
    }
    return newList;
  };

  const setMaxL = (l) => {
    if (l) {
      setMaxH(l);
    }
  };

  const setMinL = (l) => {
    if (l) {
      setMinH(l);
    }
  };

  const setLink = (l) => {
    setDoc(l);
  };

  const setNodeId = (l) => {
    if (l) {
      setNodeType(l);
    }
  };

  return (
    <div className="form-col1_6">
      <label className="form-label" for="grid-Screw">
        {t("Connector")}
        {supportEta ? (
          <a href={doc} download={doc} target="_blank" rel="noreferrer">
            {" "}
            [Pdf]
          </a>
        ) : (
          <div></div>
        )}
      </label>
      <select className="form-select" id="grid-Screw" name="grid-Screw" onChange={onChange} defaultValue={selectValue}>
        {getOptions().map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
};

export default React.forwardRef(ScrewPicker);
